import { render, staticRenderFns } from "./BasedOnAplicationForEdit.vue?vue&type=template&id=1462a28a&"
import script from "./BasedOnAplicationForEdit.vue?vue&type=script&lang=js&"
export * from "./BasedOnAplicationForEdit.vue?vue&type=script&lang=js&"
import style0 from "./BasedOnAplicationForEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports